<template>
    <div>

        <general-header
            v-bind:content="{
                header: 'Contact Us',
                subheader: '',
                buttonText: '',
                buttonIcon: '',
                iconPosition: '',
                to: '',
                link: ''
            }">
        </general-header>

        <section class="contact-main">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        Contact us <a href="mailto:innermonkdesign@gmail.com">here</a> through email and we'll get back to use quick as we can. Thank you.
                    </div>
                </div>
            </div>
        </section>

        <!-- <general-header
            v-bind:content="{
                header: '',
                subheader: '',
                buttonText: '',
                buttonIcon: '',
                iconPosition: '',
                to: ''
            }">
        </general-header> -->

    </div>
</template>

<script>
export default {
    name: 'contact',
    data () {
        return {
        }
    },
    computed: {
    },
    methods: {
    },
    mounted () {
    },
    validations: {
    }
}
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/components/_variables.scss';

    .contact-main {
        padding: 55px 0;
    }
</style>
